let factory: ((prefix: string) => string) | null = null;

/** Generates a URL-safe random identifier using the Web Crypto API (no network, no deps). */
export function createId(prefix = ''): string {
  if (factory) return factory(prefix);
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  const body = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return prefix ? `${prefix}_${body}` : body;
}

/**
 * Runs synchronous `work` with every `createId` call answered by `ids`, so domain operations
 * produce reproducible identifiers (assistant creation packages, Phase 5A). The previous
 * factory is restored afterwards, even if `work` throws.
 */
export function withIdFactory<T>(ids: (prefix: string) => string, work: () => T): T {
  const previous = factory;
  factory = ids;
  try {
    return work();
  } finally {
    factory = previous;
  }
}

export function nowIso(): string {
  return new Date().toISOString();
}
